<template>
  <van-popup
    class="bottom-download-popup"
    v-model:show="showBottomDownload"
    position="bottom"
    teleport="#app"
    :close-on-click-overlay="false"
    round
    :overlay-style="{ background: 'rgba(0, 0, 0, .5)' }"
  >
    <div class="popup-content flex-start">
      <img class="logo" v-lazy="downloadLogoSrc" />
      <div class="info">
        <div class="title flex-col">
          <span class="text1">下载APP领8888红包！</span>
          <span class="text2">联系在线客服申领</span>
        </div>
        <van-space class="action-bar" :size="15">
          <van-button class="action-btn" block @click="close(!1)">取消</van-button>
          <van-button class="action-btn" type="primary" block @click="downloadHandle">下载</van-button>
        </van-space>
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from '@star/languages';
import { storeToRefs, useModalStore, useTenantStore } from '@star/stores';
import { useDownloadApp } from '@/hooks';

const { n } = useI18n();
const { downloadLogoSrc } = storeToRefs(useTenantStore());
const { isShowTopDownload } = storeToRefs(useModalStore());
const { showBottomDownload, close, downloadHandle, init } = useDownloadApp('bottom');

onMounted(() => {
  if (!isShowTopDownload.value) {
    init('bottom');
  }
});
</script>

<style lang="less" scoped>
.bottom-download-popup {
  height: 352px;
  overflow: hidden;
  max-width: 1128px;
  left: 50%;
  transform: translate(-50%, 0); /* 通过 transform 实现精确居中 */
  bottom: 0;

  .popup-content {
    width: 100%;
    height: 100%;
    padding: 0 60px;
  }

  .logo {
    height: 150px;
    margin-top: -60px;
  }

  .info {
    margin-left: 90px;
    flex: 1;

    .title {
      font-size: 45px;
      font-weight: 500;
      line-height: 1.2;
      color: #4b4b4b;

      .text2 {
        font-size: 36px;
        margin-top: 10px;
        font-weight: 400;
      }
    }
  }

  .action-btn {
    width: 300px;
    height: 105px;
    border-radius: 20px;
    font-size: 42px;
    font-weight: 380;
    margin-top: 60px;

    &.van-button--primary {
      background: var(--van-button-primary-background);
      color: var(--van-button-primary-color);
    }

    &.van-button--default {
      color: #aaa;
      border-width: 3px;
    }
  }
}
</style>
